export default __webpack_public_path__ + "static/media/icon-rank.5992b105.svg";